export const bs = {

    methods: {
        boxClass(bs) {
            if (bs == 'bs3') {
                return {
                    box: 'panel panel-default',
                    boxHeader: 'panel-heading',
                    boxBody: 'panel-body',
                    noPadding: 'no-padding'
                }

            } else if (bs == 'evt') {
                return {
                    box: 'box box-default',
                    boxHeader: 'box-header with-border',
                    boxBody: 'box-body',
                    noPadding: 'no-padding'
                }
            } else {
                return {
                    box: 'card card-default',
                    boxHeader: 'card-header',
                    boxBody: 'card-body',
                    noPadding: 'px-0 py-0'
                }
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/Assets/mixins/bs.js